import { render, staticRenderFns } from "./EntrepriseDetails.vue?vue&type=template&id=485422de&"
import script from "./EntrepriseDetails.vue?vue&type=script&lang=js&"
export * from "./EntrepriseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports